import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_SRC = 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/chatgpt-image-18-2-3-2026-3-08-35-06.png';

export default function Logo({ variant = 'default', className = '' }) {
  const isLight = variant === 'light';

  return (
    <Link
      to="/"
      className={`inline-flex items-center group text-left ${className}`}
      aria-label="Morine Køl & Klimateknik - Gå til forside"
    >
      <img
        src={LOGO_SRC}
        alt="Morine Køl & Klimateknik"
        className={`h-14 sm:h-16 md:h-20 max-h-24 w-auto object-contain transition-transform duration-200 group-hover:scale-105 ${
          isLight ? 'brightness-105' : ''
        }`}
      />
    </Link>
  );
}
